import { getDefaultStatisticItem } from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null

export default {
  statisticScheme: {
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true,  editable: false }),
    'TRY': getDefaultStatisticItem(),
    'CONVERSION_GOAL': getDefaultStatisticItem(),
    'DROP_GOAL': getDefaultStatisticItem(),
    'FREE_KICK': getDefaultStatisticItem()
  },
  statisticEvents: {
    'TRY': 'TRY',
    'CONVERSION_GOAL': 'CONVERSION_GOAL',
    'DROP_GOAL': [
      'DROP_GOAL',
      'DROP_GOAL_10_METERS_ATTACK',
      'DROP_GOAL_10_METERS_DEFENCE',
      'DROP_GOAL_20_METERS_ATTACK',
      'DROP_GOAL_20_METERS_DEFENCE',
      'DROP_GOAL_30_METERS_ATTACK',
      'DROP_GOAL_30_METERS_DEFENCE',
      'DROP_GOAL_40_METERS_ATTACK',
      'DROP_GOAL_40_METERS_DEFENCE',
      'DROP_GOAL_50_METERS_POSSESSION'
    ],
    'FREE_KICK': [
      'FREE_KICK',
      'FREE_KICK_10_METERS_ATTACK',
      'FREE_KICK_10_METERS_DEFENCE',
      'FREE_KICK_20_METERS_ATTACK',
      'FREE_KICK_20_METERS_DEFENCE',
      'FREE_KICK_30_METERS_ATTACK',
      'FREE_KICK_30_METERS_DEFENCE',
      'FREE_KICK_40_METERS_ATTACK',
      'FREE_KICK_40_METERS_DEFENCE',
      'FREE_KICK_50_METERS_POSSESSION'
    ]
  },
  statisticOrder: [
    'possession',
    'TRY',
    'CONVERSION_GOAL',
    'DROP_GOAL',
    'FREE_KICK'
  ],
  statisticFunction (event) {
    getCommonPossessionStatistic.bind(this)(event)
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

function updateFunction ({ period, team, type, value }) {
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period,
    team,
    type,
    value
  })
}

function getCommonPossessionStatistic (event) {
  const updateStatistic = updateFunction.bind(this)
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]

  if (!getActiveSide && !previousActiveSide) return

  if (EventCode === 'START_PERIOD' || overriddenType === 'shootout') {
    previousPlayTime = Playtime

    return
  }

  if (EventCode === 'STOP_GAME_CLOCK') {
    updateStatistic({
      type: 'increment',
      period: GamePeriod || getCurrentPeriod,
      team: previousActiveSide,
      value: Playtime - previousPlayTime
    })
  }

  if (isTimerStoped) {
    previousPlayTime = Playtime

    return
  }

  if (previousActiveSide !== getActiveSide) {
    if (previousActiveSide) {
      updateStatistic({
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    previousActiveSide = getActiveSide
    previousPlayTime = Playtime

    return
  }

  updateStatistic({
    period: GamePeriod || getCurrentPeriod,
    team: getActiveSide,
    type: 'increment',
    value: Playtime - previousPlayTime
  })

  previousPlayTime = Playtime
}
